export default __webpack_public_path__ + "static/SupremeLL-Italic-0d63137d4c2cf2477317905c5c93c1ca.woff";